import {ContactInternalInfoDTO} from "./contactInternalInfoDTO.interface";
import {ContactDTO} from "./contactDTO.interface";

export interface ContactAdminDTO extends ContactDTO {
  contactInternalInfo?: ContactInternalInfoDTO;
}
